import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import './GuildWarCount.css';

const GuildWar = () => {
  const [guildName, setGuildName] = useState('');
  const [gid, setGid] = useState('');
  const [defenders, setDefenders] = useState([]);
  const [event, setEvent] = useState('null');
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [sortConfig, setSortConfig] = useState({ key: 'pvpLeaguePhase', direction: 'ascending' });
  
  const [selectedDefender, setSelectedDefender] = useState(null);
  const [lineName, setLineName] = useState('');
  const [group, setGroup] = useState('');
  const [updateMsg, setUpdateMsg] = useState('');
  const [selectedLineUser, setSelectedLineUser] = useState(null);
  const [lineMembers, setLineMembers] = useState([]);
  const [isLoadingLine, setIsLoadingLine] = useState(false);

  // 追加: メンバー一括登録
  const [importResult, setImportResult] = useState(null);
  const [importLoading, setImportLoading] = useState(false);

  // 展開状態
  const [showImport, setShowImport] = useState(false);

  // membersData（指定内容）
  const membersData = {
    "r6rzejlha3xyypi3f6yle5uycgivbeq": { "lineName": "Yuga", "group": "C" },
    "r21e40rtqccvnbawscf9cktcz9r2jx1": { "lineName": "AREI", "group": "A" },
    "rmx1asthpy1rpp3idsijkanxnqj4sh6": { "lineName": "AREI", "group": "B" },
    "rfi9favne20dd9apjyihgczv5bkr4gs": { "lineName": "AREI", "group": "A" },
    "rcckz6iv07z0hwh3p3vz7hijvcduvhj": { "lineName": "-", "group": "A" },
    "rog5ltsdvv5pdtxeoeebwwp3f23qz9s": { "lineName": "横田洋子", "group": "A" },
    "roztlew5z3lnfh7jacmza529fcacrp6": { "lineName": "박용용", "group": "A" },
    "reudeiuqr6rjd775aptim8nrhtxx652": { "lineName": "M.", "group": "B" },
    "rutjpmr6p3kx4way5qhobcpgvqm9ksz": { "lineName": "AREI", "group": "A" },
    "rm8jxqy3nqc8dfmj9mv4xynop4eh5sb": { "lineName": "楊旭華", "group": "B" },
    "rvhmfci1sflf8juewyin4cmcgpsw35p": { "lineName": "䒕富", "group": "C" },
    "rmh9dejftqvclnz5ids1xrvdwtaui7h": { "lineName": "Chen JinFu", "group": "C" },
    "rd7ie9z5wsvedbniefavmzgbrqwr31g": { "lineName": "和好不如初", "group": "B" },
    "rvt7ow1ex8nntaxmo1jqcpkv0rzbsoc": { "lineName": "威廷", "group": "A" },
    "r2j57kksx7250lzsq0jq2mcuywazgd9": { "lineName": "洪柏文", "group": "B" },
    "rrh2rgwdmdm6mjezmhjhgi1t2ny8fvx": { "lineName": "-", "group": "C" },
    "rj2okf1ognh5qf79fw359k905n4gehq": { "lineName": "T.W. (•ε•)", "group": "A" },
    "r8zmevk87tx9jjs50dmgzfpnvoraed1": { "lineName": "T.W. (•ε•)", "group": "A" },
    "rxksngb3jndw9qm0njgh7zuzxgyatte": { "lineName": "-", "group": "B" },
    "rwb9zoxpszz1oerq98ki1gntbxjlwbl": { "lineName": "Leo", "group": "B" },
    "rzilpyge3upmp9piugeegx20gwxhqf9": { "lineName": "信如刀哥", "group": "A" },
    "r03sl8fke03u9ss3el4il4sc429chpn": { "lineName": "Stephan Lao", "group": "B" },
    "rvo8otxycllmaiaeleu1farbqlgubps": { "lineName": "Hiro.ak", "group": "A" },
    "r2ixjvzmmlueerxy8xixbefptnwgjxt": { "lineName": "Yuga", "group": "B" },
    "rcqklvjrtdmwn6pnvzbtdalahrf4tu7": { "lineName": "AREI", "group": "B" },
    "rn44utgci4tz8mtmt8uijotqlcqvon7": { "lineName": "Mark C.", "group": "B" },
    "r0hoyl5t85yvsvuwlxhuqby4dk46uu2": { "lineName": "翁徵凱", "group": "B" },
    "rngstqssgsaw58dpb4mw0yl1kba6cnr": { "lineName": "성진우", "group": "A" },
    "rik9y20foolslgecl6ae52netd2mxsf": { "lineName": "紅茶", "group": "B" },
    "rnmqjopy4hiepof6irot0egsfedovxm": { "lineName": "Evelyn 2515", "group": "A" },
    "rkbz77w1wpnowrim0e3a6988z1lgw3z": { "lineName": "リョウスケ", "group": "A" },
    "r3aa8pc30m0e6pomnak4wc32dudy5z1": { "lineName": "RC", "group": "B" },
    "rf1fzshj6ebcjimckamputahaf7v14a": { "lineName": "Sung", "group": "B" },
    "rvkcdvblgvjp1xwiddr3ftfqwnegzj2": { "lineName": "AREI", "group": "B" },
    "rvrevnogfp1kinbzwar4dgnknpeczxo": { "lineName": "望", "group": "A" },
    "rf8mcsasjevdascwzvn4ebspy1vpfem": { "lineName": "-", "group": "C" },
    "rrq0wixsfcvne0wuhonrez5hdjbmgvn": { "lineName": "王錦文", "group": "C" },
    "rklwb8bua2wudeexqc795nkzaz41sot": { "lineName": "Ryohey", "group": "B" },
    "rjfodt5wthqlgjyvvmxuz16xgom2vxq": { "lineName": "小林将也", "group": "B" },
    "r42hmx1kwgyobfnqiwvhi0d87s6lnzp": { "lineName": "Jaraspong", "group": "B" },
    "rv27qt8sdonkigp2dhhwvbfx70b2luf": { "lineName": "-", "group": "B" },
    "rmwlcew2fifrkr1dyxxruzr4qnrxuph": { "lineName": "osa0923", "group": "A" },
    "rlaeyifatwd9lyohvll1ygh36bsc3uj": { "lineName": "AREI", "group": "A" },
    "r63gzuj3146wqribm0wjluvjgpcxeb5": { "lineName": "AREI", "group": "B" },
    "r1kt31w0e92kq68t09mgie5d35h20ms": { "lineName": "h", "group": "B" },
    "r3qat7tdhvicdgvkk2w0enmnhbq5vbx": { "lineName": "百武", "group": "C" },
    "ro21ivcff6y8jciegavutg9wbno0dhw": { "lineName": "Kai", "group": "C" },
    "rkxvy8ihf9ypvjslgz1f5c0ywhvx7ga": { "lineName": "小笠原空良", "group": "C" },
    "r1vpbjopzfxn4ulw8ifbgvdohytfn2v": { "lineName": "葉盛峵", "group": "A" },
    "rh1imrpgq07psfnt646grz20zdvctpa": { "lineName": "-", "group": "A" },
    "rnjlvg4e1j53xj37n9vfyyqdypskbn1": { "lineName": "TOSHIYA", "group": "A" },
    "rqoybezq3p8zxjf3zyfx92nqg3f6ysz": { "lineName": "賴堯民 Alvin", "group": "C" },
    "ribskczt3izabyylhlbdxmfwfxnok1a": { "lineName": "Gary", "group": "A" },
    "rnmxc8b7sx8i2ez5cd0dd87drnw3wyu": { "lineName": "饅頭人UR", "group": "A" },
    "rdoj3626v5u4jjtp9ri5cethiswckas": { "lineName": "*great*", "group": "B" },
    "rrz23ldty86wbpu52gb12l2lachc9q1": { "lineName": "Stephan Lao", "group": "A" },
    "rq7r3bypar58zbkbtf08pzu7trejo6q": { "lineName": "李小龍", "group": "C" }
  };

  const fetchLineMembers = useCallback(async () => {
    setIsLoadingLine(true);
    try {
      const res = await axios.get(`https://rangers-api-3mfw.onrender.com/api/line/group-members`, {
        params: { groupId: 'Cf45d54ef764b15d507cdcb17d02ff5b7' },
      });
      setLineMembers(res.data);
    } catch {
      // LINE メンバーが取得できなくても続行
    } finally {
      setIsLoadingLine(false);
    }
  }, []);

  const fetchGuildWarData = useCallback(async () => {
    setIsLoading(true);
    try {
      setIsError(false);

      // 毎回APIからデータを取得（Rangers APIから最新データを取得）
      const response = await axios.get(
        `https://rangers-api-3mfw.onrender.com/api/guild-info-cma/5be953486a32da5b2aff5a7b8f8833d1/members`,
        {
          params: {
            eventType: event,
          },
        }
      );

      const data = response.data;

      setDefenders(data);

      // 自動登録処理: lineName, groupが設定されていないユーザーに対してmembersDataから登録
      await autoRegisterMissingMembers(data);

    } catch (error) {
      setIsError(true);
      console.error('データの取得中にエラーが発生しました:', error);
    } finally {
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event]);

  // 新しい関数: lineName, groupが未設定のメンバーを自動登録
  const autoRegisterMissingMembers = async (defenders) => {
    try {
      const missingMembers = defenders.filter(defender => {
        const hasLineName = defender.lineName && defender.lineName.trim() !== '' && defender.lineName !== '-';
        const hasGroup = defender.group && defender.group.trim() !== '' && defender.group !== '-';
        const hasDataInMembersData = membersData[defender.uid];
        
        if (!hasDataInMembersData) return false;
        
        const memberData = membersData[defender.uid];
        // membersDataのlineNameまたはgroupが"-"の場合は更新対象外
        const memberDataHasValidLineName = memberData.lineName && memberData.lineName.trim() !== '' && memberData.lineName !== '-';
        const memberDataHasValidGroup = memberData.group && memberData.group.trim() !== '' && memberData.group !== '-';
        
        // 更新が必要な条件：
        // 1. 現在のlineNameが未設定で、membersDataに有効なlineNameがある
        // 2. 現在のgroupが未設定で、membersDataに有効なgroupがある
        // 3. 現在の値とmembersDataの値が異なる場合のみ
        const needLineNameUpdate = !hasLineName && memberDataHasValidLineName && defender.lineName !== memberData.lineName;
        const needGroupUpdate = !hasGroup && memberDataHasValidGroup && defender.group !== memberData.group;
        
        return needLineNameUpdate || needGroupUpdate;
      });

      if (missingMembers.length > 0) {
        console.log(`${missingMembers.length}人のメンバーに自動登録を実行します...`);
        
        // 更新されたメンバー情報を格納する配列
        const updatedMembers = [];
        
        // 各メンバーに対して順次更新
        for (const member of missingMembers) {
          const memberData = membersData[member.uid];
          if (memberData) {
            try {
              await axios.put(`https://rangers-api-3mfw.onrender.com/api/guilds/update-line-group`, {
                uid: member.uid,
                lineName: memberData.lineName,
                group: memberData.group,
              });
              console.log(`${member.userName} (${member.uid}) の情報を更新しました: LINE=${memberData.lineName}, Group=${memberData.group}`);
              
              // 更新成功したメンバーの情報を記録
              updatedMembers.push({
                uid: member.uid,
                lineName: memberData.lineName,
                group: memberData.group
              });
              
            } catch (updateError) {
              console.error(`${member.userName} (${member.uid}) の更新に失敗しました:`, updateError);
            }
          }
        }
        
        // ローカルのdefendersデータを更新（APIリクエストなし）
        if (updatedMembers.length > 0) {
          const updatedDefenders = defenders.map(defender => {
            const updatedMember = updatedMembers.find(um => um.uid === defender.uid);
            if (updatedMember) {
              return {
                ...defender,
                lineName: updatedMember.lineName,
                group: updatedMember.group
              };
            }
            return defender;
          });
          setDefenders(updatedDefenders);
        }
      }
    } catch (error) {
      console.error('自動登録処理中にエラーが発生しました:', error);
    }
  };

  useEffect(() => {
    fetchGuildWarData();
    fetchLineMembers();
  }, [gid, event, fetchGuildWarData, fetchLineMembers]);

  useEffect(() => {
    if (defenders.length > 0) {
      setSortConfig({ key: 'level', direction: 'descending' });
    }
  }, [defenders]);

  const translateLevel = (level) => {
    if (level >= 1 && level <= 99) {
      return `${level}`;
    } else if (level >= 100 && level <= 198) {
      return `M${level - 99}`;
    } else if (level >= 199 && level <= 297) {
      return `S${level - 198}`;
    } else if (level >= 298 && level <= 396) {
      return `U${level - 297}`;
    } else if (level >= 397 && level <= 495) {
      return `L${level - 396}`;
    } else if (level >= 496) {
      return `S'${level - 495}`;
    } else {
      return 'unknown';
    }
  };

  // lastAccessTimeDiff（ミリ秒）を人間が読みやすい形式に変換（英語表記）
  const formatLastAccess = (milliseconds) => {
    if (!milliseconds || milliseconds === 0) return '-';
    
    const seconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    if (years > 0) return `${years}y ago`;
    if (months > 0) return `${months}mo ago`;
    if (days > 0) return `${days}d ago`;
    if (hours > 0) return `${hours}h ago`;
    if (minutes > 0) return `${minutes}m ago`;
    return `${seconds}s ago`;
  };

  const sortedDefenders = [...defenders].sort((a, b) => {
    const { key, direction } = sortConfig;
    const order = direction === 'ascending' ? 1 : -1;

    try {
      if (key === 'level') {
        return order * ((a.level || 0) - (b.level || 0));
      } else if (key === 'userName') {
        return order * (a.userName || '').localeCompare(b.userName || '');
      } else if (key === 'lineName') {
        return order * (a.lineName || '').localeCompare(b.lineName || '');
      } else if (key === 'group') {
        return order * (a.group || '').localeCompare(b.group || '');
      } else if (key === 'lastAccessTimeDiff') {
        return order * ((a.lastAccessTimeDiff || 0) - (b.lastAccessTimeDiff || 0));
      }
      return 0;
    } catch (error) {
      console.error('Sorting error:', error);
      return 0; // エラーが発生した場合は、元の順序を保持
    }
  });

  const requestSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'ascending' ? '↑' : '↓';
    }
    return '⇅'; // デフォルトの矢印アイコン
  };

  const closeForm = () => {
    setSelectedDefender(null);
    setLineName('');
    setGroup('');
    setSelectedLineUser(null);
  };

  const handleSelectLineUser = (member) => {
    if (selectedLineUser?.userId === member.userId) {
      setSelectedLineUser(null);
      setLineName(selectedDefender?.lineName || '');
    } else {
      setSelectedLineUser(member);
      setLineName(member.displayName);
    }
  };

  const handleUpdate = async () => {
    if (!selectedDefender) return;

    const targetUid = selectedDefender.uid;
    const targetLineName = lineName || (selectedLineUser ? selectedLineUser.displayName : '-');
    const targetLineUserId = selectedLineUser ? selectedLineUser.userId : null;
    const targetGroup = group || selectedDefender.group || '-';

    // Optimistic UI update
    setDefenders(prev =>
      prev.map(d =>
        d.uid === targetUid
          ? { ...d, lineName: targetLineName, lineUserId: targetLineUserId, group: targetGroup }
          : d
      )
    );

    closeForm();
    setUpdateMsg('✓ 通信中...');

    try {
      if (selectedLineUser) {
        await axios.post(`https://rangers-api-3mfw.onrender.com/api/line/link-member`, {
          lineUserId: targetLineUserId,
          lineDisplayName: targetLineName,
          gameUid: targetUid,
          gameGroup: targetGroup,
          gid: '5be953486a32da5b2aff5a7b8f8833d1',
        });
      } else {
        await axios.put(`https://rangers-api-3mfw.onrender.com/api/guilds/update-line-group`, {
          uid: targetUid,
          lineName: targetLineName,
          group: targetGroup,
        });
      }
      setUpdateMsg('✓ 更新しました');
      setTimeout(() => setUpdateMsg(''), 3000);
    } catch (err) {
      setUpdateMsg(`エラー: ${err.response?.data?.error || err.message}`);
    }
  };

  const handleUnlink = async () => {
    if (!selectedDefender) return;
    if (!window.confirm(`${selectedDefender.userName} の紐付けを解除しますか？`)) return;

    const targetUid = selectedDefender.uid;

    // Optimistic UI update
    setDefenders(prev =>
      prev.map(d =>
        d.uid === targetUid ? { ...d, lineName: '-', lineUserId: null } : d
      )
    );

    closeForm();
    setUpdateMsg('✓ 通信中...');

    try {
      await axios.delete(`https://rangers-api-3mfw.onrender.com/api/line/unlink-member`, {
        data: { gameUid: targetUid, gid: '5be953486a32da5b2aff5a7b8f8833d1' },
      });
      setUpdateMsg('✓ 紐付けを解除しました');
      setTimeout(() => setUpdateMsg(''), 3000);
    } catch (err) {
      setUpdateMsg(`エラー: ${err.response?.data?.error || err.message}`);
    }
  };

  const handleImportMembers = async () => {
    if (!window.confirm('このボタンはYuga専用です')) return;
    setImportLoading(true);
    setImportResult(null);
    try {
      const res = await axios.post('https://rangers-api-3mfw.onrender.com/api/guilds/import-guild-members', membersData);
      setImportResult({ success: true, message: res.data.message + ' (' + res.data.count + '件)' });

      // データを再取得
      await fetchGuildWarData();
    } catch (err) {
      setImportResult({ success: false, message: err.message });
    } finally {
      setImportLoading(false);
    }
  };

  const lineUserMap = Object.fromEntries(lineMembers.map(m => [m.userId, m]));
  const linkedLineUserIds = new Set(
    defenders.filter(d => d.lineUserId && d.uid !== selectedDefender?.uid).map(d => d.lineUserId)
  );

  return (
    <div className="guild-war-container">
      <div className="select-group">
        <h1>CMA Info</h1>
      </div>

      {updateMsg && (
        <p style={{ color: updateMsg.startsWith('エラー') ? 'red' : '#4caf50', fontWeight: 'bold', margin: '8px 0' }}>
          {updateMsg}
        </p>
      )}

      {isError ? (
        <p>An error occurred while retrieving data. Please try again.</p>
      ) : isLoading ? (
        <p>Loading data...(It may take several minutes)</p>
      ) : (
        <>
          <br />
          <div className="table-container">
            <table className="defender-table">
              <thead>
                <tr>
                  <th onClick={() => requestSort('level')}>Lv {getSortIcon('level')}</th>
                  <th onClick={() => requestSort('userName')}>Name {getSortIcon('userName')}</th>
                  <th onClick={() => requestSort('lineName')}>LINE {getSortIcon('lineName')}</th>
                  <th onClick={() => requestSort('group')}>Grp {getSortIcon('group')}</th>
                  <th onClick={() => requestSort('lastAccessTimeDiff')}>Last {getSortIcon('lastAccessTimeDiff')}</th>
                </tr>
              </thead>
              <tbody>
                {sortedDefenders.map((defender) => {
                  const userLevel = translateLevel(defender.level || 0);
                  const playerName = defender.userName || 'unknown';
                  const lineName = defender.lineName || 'unknown';
                  const group = defender.group || 'unknown';
                  const lastAccess = formatLastAccess(defender.lastAccessTimeDiff || 0);

                  return (
                    <tr key={defender.uid} className="defender-row" onClick={() => {
                      setSelectedDefender(defender);
                      setLineName(defender.lineName);
                      setGroup(defender.group);
                      const linked = lineMembers.find(l => l.userId === defender.lineUserId);
                      setSelectedLineUser(linked || null);
                    }}>
                      <td>{userLevel}</td>
                      <td>
                        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                          {defender.imageUrl && (
                            <img
                              src={`https://rangers.lerico.net/res/user_profile_img/${defender.imageUrl}.png`}
                              alt=""
                              style={{ width: 22, height: 22, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
                              onError={(e) => { e.target.style.display = 'none'; }}
                            />
                          )}
                          {playerName}
                        </span>
                      </td>
                      <td>
                        {defender.lineUserId ? (
                          <span style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#4caf50' }}>
                            {lineUserMap[defender.lineUserId]?.pictureUrl ? (
                              <img
                                src={lineUserMap[defender.lineUserId].pictureUrl}
                                alt=""
                                style={{ width: 22, height: 22, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
                              />
                            ) : (
                              <div style={{ width: 22, height: 22, borderRadius: '50%', background: '#2d5a2d', flexShrink: 0 }} />
                            )}
                            {lineName}
                          </span>
                        ) : lineName}
                      </td>
                      <td>{group}</td>
                      <td>{lastAccess}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {selectedDefender && (
  <div className="update-form">
    <h2>Updating: {selectedDefender.userName}</h2>

    {/* LINE メンバー選択リスト */}
    <div style={{ marginBottom: 10 }}>
      <p style={{ fontSize: 12, color: '#aaa', margin: '0 0 6px' }}>
        LINEメンバーから選択（または下のテキストで直接入力）
      </p>
      {isLoadingLine ? (
        <p style={{ fontSize: 12, color: '#888' }}>LINE members loading...</p>
      ) : lineMembers.length === 0 ? (
        <p style={{ fontSize: 12, color: '#888' }}>
          LINEメンバーが見つかりません（グループ内でメッセージが届くと自動で蓄積されます）
        </p>
      ) : (
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 6,
          maxHeight: 180,
          overflowY: 'auto',
          padding: 6,
          border: '1px solid #444',
          borderRadius: 4,
        }}>
          {lineMembers.map(member => {
            const isSelected = selectedLineUser?.userId === member.userId;
            const isLinkedElsewhere = linkedLineUserIds.has(member.userId) && selectedDefender?.lineUserId !== member.userId;
            return (
              <div
                key={member.userId}
                onClick={() => handleSelectLineUser(member)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 6,
                  padding: '4px 10px',
                  borderRadius: 20,
                  border: isSelected ? '2px solid #4a9eff' : isLinkedElsewhere ? '2px solid #bd9b3b' : '1px solid #ccc',
                  backgroundColor: isSelected ? 'rgba(74, 158, 255, 0.15)' : '#ffffff',
                  color: isSelected ? 'inherit' : '#333',
                  cursor: 'pointer',
                  opacity: 1,
                  fontSize: 13,
                }}
                title={isLinkedElsewhere ? 'すでに他のメンバーにも紐付けされています（サブ垢用等の再選択）' : ''}
              >
                {member.pictureUrl ? (
                  <img src={member.pictureUrl} alt="" style={{ width: 22, height: 22, borderRadius: '50%' }} />
                ) : (
                  <div style={{ width: 22, height: 22, borderRadius: '50%', background: '#555', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11 }}>?</div>
                )}
                <span>{member.displayName}</span>
                {isLinkedElsewhere && <span style={{ fontSize: 10, color: '#888' }}>（使用中）</span>}
              </div>
            );
          })}
        </div>
      )}
    </div>

    <input
      type="text"
      value={lineName}
      onChange={(e) => {
        setLineName(e.target.value);
        if (selectedLineUser && e.target.value !== selectedLineUser.displayName) {
          setSelectedLineUser(null);
        }
      }}
      placeholder="LINE Name"
    />
    <input
      type="text"
      value={group}
      onChange={(e) => setGroup(e.target.value)}
      placeholder="Group"
    />
    <div style={{ marginTop: 10, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
      <button onClick={handleUpdate}>
        {selectedLineUser ? 'Link & Update' : 'Update'}
      </button>
      {selectedDefender.lineUserId && (
        <button onClick={handleUnlink} style={{ background: '#c00' }}>
          Unlink
        </button>
      )}
      <button onClick={closeForm} style={{ background: '#555' }}>
        Cancel
      </button>
    </div>
  </div>
)}
          <br />
          <div style={{ margin: '1em 0' }}>
            <a href="#" onClick={e => { e.preventDefault(); setShowImport(v => !v); }} style={{ cursor: 'pointer', color: '#007bff', textDecoration: 'underline' }}>
              {showImport ? 'close debug' : 'open debug'}
            </a>
            {showImport && (
              <div style={{ marginTop: '1em' }}>
                <button onClick={handleImportMembers} disabled={importLoading}>
                  {importLoading ? '送信中...' : 'メンバー一括登録'}
                </button>
                {importResult && (
                  <div style={{ color: importResult.success ? 'green' : 'red', marginTop: '0.5em' }}>{importResult.message}</div>
                )}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default GuildWar;
